// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VpGK","selected":"styles_selected__3kYs3"};